'use client';

import create from 'zustand';

import { PERIL_STAGE } from './threeStore';

export type CUSTOM_CAMERA_VARIANT =
  | 'SPACE'
  | 'TILES'
  | 'WEATHER'
  | Exclude<PERIL_STAGE, 'HIDDEN'>;

interface CustomCameraState {
  variant: CUSTOM_CAMERA_VARIANT;
  setCustomCameraVariant: (variant: CUSTOM_CAMERA_VARIANT) => void;
}

export const useCustomCameraStore = create<CustomCameraState>(set => ({
  variant: 'SPACE',
  setCustomCameraVariant: variant => set({ variant }),
}));
